import request from '@/utils/requestVr'
// 查询空存储归档续费分页
export function fetchList(query) {
    return request({
        url: '/vr/storage/renew/page',
        method: 'get',
        params: query,
    })
}
// 查询空存储归档续费分页对外
export function fetchLists(query) {
    return request({
        url: '/vr/storage/package/page/way',
        method: 'get',
        params: query,
    })
}
// 查询存储归档续费详细
export function getObj(id) {
    return request({
        url: '/vr/storage/renew/detail?id=' + id,
        method: 'get',
    })
}
// 新增存储归档续费
export function addObj(data) {
    return request({
        url: '/vr/storage/renew/add',
        method: 'post',
        data: data,
    })
}
// 禁用启用存储归档续费
export function editStatus(data) {
    return request({
        url: '/vr/storage/package/status',
        method: 'post',
        data: data,
    })
}
// 修改存储归档续费
export function putObj(data) {
    return request({
        url: '/vr/storage/renew/edit',
        method: 'post',
        data: data,
    })
}
// 删除存储归档续费
export function delObj(data) {
    return request({
        url: '/vr/storage/package/delete',
        method: 'post',
        data: data,
    })
}

export function getDetail(params) {
  return request({
    url: '/vr/storage/renew/detail',
    method: 'GET',
    params,
  })
}
